/**
 * Privacy-safe per-user identifier for analytics (truncated SHA-256, salted).
 * Hash is stored as sessionStorage['analytics_user_id'].
 */

import {setUserId} from 'firebase/analytics';
import env from 'env';

import {analyticsPromise} from './firebase';

const ANALYTICS_USER_ID_SALT = 'valkyrie-analytics';
const ANALYTICS_USER_ID_KEY = 'analytics_user_id';
/** First 8 bytes of SHA-256 → 16 hex chars (64 bits). */
const ANALYTICS_USER_ID_HASH_BYTE_LENGTH = 8;

export const resolveKycUserId = (data) => data?.user_id || data?.userId || data?.id || null;

const hashUserIdForAnalytics = async (rawUserId) => {
  if (!rawUserId || typeof window === 'undefined' || !crypto?.subtle) {
    return null;
  }

  const input = `${ANALYTICS_USER_ID_SALT}:${String(rawUserId)}`;
  const data = new TextEncoder().encode(input);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hashBuffer).slice(0, ANALYTICS_USER_ID_HASH_BYTE_LENGTH))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

export const getAnalyticsUserId = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return sessionStorage.getItem(ANALYTICS_USER_ID_KEY);
};

export const setAnalyticsUserId = async (rawUserId) => {
  if (!rawUserId) {
    return null;
  }

  const hashedUserId = await hashUserIdForAnalytics(rawUserId);

  if (!hashedUserId || typeof window === 'undefined') {
    return null;
  }

  sessionStorage.setItem(ANALYTICS_USER_ID_KEY, hashedUserId);

  const analytics = await analyticsPromise;

  if (analytics) {
    setUserId(analytics, hashedUserId);
  }

  return getAnalyticsUserId();
};
